import { makeStyles } from '@material-ui/core';

/**
 * Local clone of common FormField's ~20 lines of label/helper styling
 * (common is frozen and does not export these) so the merged control visually
 * matches the surrounding FormField/FormAutocomplete fields.
 */
export const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    marginBottom: '2rem',
    '& input:-webkit-autofill': {
      ' -webkit-text-fill-color': 'inherit !important',
      '-webkit-box-shadow': '0 0 0 100px #fff inset !important'
    },
    '& .MuiFormLabel-filled, & .Mui-focused': {
      fontWeight: 'bold'
    },
    '& label.MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -9px) scale(0.75) !important'
    }
  },
  helperZone: {
    marginTop: '12px',
    minHeight: '1.75rem'
  },
  helperText: {
    lineHeight: '1.5 !important'
  },
  counter: {
    margin: 0,
    paddingLeft: '0.9rem',
    whiteSpace: 'nowrap'
  }
}));
